document.addEventListener('DOMContentLoaded', () => {
  const customOrderButtons = document.querySelectorAll('.custom-order-button');

  customOrderButtons.forEach(button => {
    const sectionId = button.dataset.section;
    const modal = document.getElementById(`custom-order-modal-${sectionId}`);
    if (!modal) return;

    const closeButton = modal.querySelector('.custom-order-close');
    const form = modal.querySelector(`#custom-order-form-${sectionId}`);
    const optionsSummary = modal.querySelector(`#custom-order-summary-${sectionId}`);
    const optionsInput = modal.querySelector(`#custom-order-options-${sectionId}`);
    const variantPicker = document.querySelector(`#variant-selects-${sectionId}`);

    function updateCustomOrderForm() {
      if (!variantPicker) return;

      const selectedOptions = Array.from(variantPicker.querySelectorAll('input[type="radio"]:checked, select'));
      let allOptionsSelected = true;
      let optionsText = '';
      const optionsContent = [];

      const fieldsets = variantPicker.querySelectorAll('fieldset, .product-form__input--dropdown');
      
      fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend, .form__label');
        const optionName = legend ? legend.innerText.split(':')[0].trim() : '';
        const optionNameLower = optionName.toLowerCase();
        const skipRequiredCheck = optionNameLower.includes('size');
        const isCanvasOption = optionNameLower.includes('canvas');
        const isFramedStretchedOption =
          optionNameLower.includes('framed') && optionNameLower.includes('stretched');
        const skipSummary = skipRequiredCheck || isCanvasOption || isFramedStretchedOption;

        const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
        const selectElement = fieldset.querySelector('select');

        let selectedValue = '';

        if (selectElement) {
            selectedValue = selectElement.value;
        } else if (selectedInput) {
            selectedValue = selectedInput.value;
        }

        if (optionName && selectedValue) {
          if (!skipSummary) {
            optionsContent.push(`<li><strong>${optionName}:</strong> ${selectedValue}</li>`);
            optionsText += `${optionName}: ${selectedValue}\n`;
          }
        } else if (optionName && !skipRequiredCheck) {
          allOptionsSelected = false;
        }
      });
      
      if (optionsSummary) {
        optionsSummary.innerHTML = optionsContent.join('');
      }
      if (optionsInput) {
        optionsInput.value = optionsText.trim();
      }
      
      // Handle GPO options
      const gpoContainer = document.querySelector(`#ProductInfo-${sectionId} .globo-product-options`);
      if (gpoContainer) {
        let gpoOptionsText = '';
        const gpoOptionsContent = [];
        const gpoFields = gpoContainer.querySelectorAll('.gpo-element');

        gpoFields.forEach(field => {
          const labelElement = field.querySelector('.gpo-label, .gpo-heading h3');
          if (!labelElement) return;

          const label = labelElement.innerText.trim().replace(/\s*\*\s*$/, '');
          let value = '';

          const textInput = field.querySelector('input[type="text"]:not([type="file"]), textarea');
          const radioInput = field.querySelector('input[type="radio"]:checked');
          const selectInput = field.querySelector('select');
          const fileInput = field.querySelector('input[type="file"]');

          if (textInput) value = textInput.value;
          else if (radioInput) value = radioInput.value;
          else if (selectInput) value = selectInput.value;
          else if (fileInput && fileInput.files.length > 0) value = fileInput.files[0].name;
          else { // Handle swatches and other custom inputs
              const checkedSwatch = field.querySelector('input:checked + label');
              if(checkedSwatch) {
                  value = checkedSwatch.innerText.trim();
              }
          }

          const labelLower = label.toLowerCase();
          const isCanvasLabel = labelLower.includes('canvas');
          const isFramedStretchedLabel =
            labelLower.includes('framed') && labelLower.includes('stretched');

          if (value && !isCanvasLabel && !isFramedStretchedLabel) {
            gpoOptionsContent.push(`<li><strong>${label}:</strong> ${value}</li>`);
            gpoOptionsText += `${label}: ${value}\n`;
          }
        });
        
        if (optionsSummary) {
          optionsSummary.innerHTML += gpoOptionsContent.join('');
        }
        if (optionsInput) {
          const currentVal = optionsInput.value;
          optionsInput.value = (currentVal + '\n' + gpoOptionsText.trim()).trim();
        }
      }

      button.disabled = !allOptionsSelected || !checkRequiredGPO();
    }

    function checkRequiredGPO() {
      const gpoContainer = document.querySelector(`#ProductInfo-${sectionId} .globo-product-options`);
      if (!gpoContainer) return true;

      const requiredInputs = gpoContainer.querySelectorAll('[data-gpo-required="true"]');
      if (requiredInputs.length === 0) return true;

      for (const inputContainer of requiredInputs) {
        const textInput = inputContainer.querySelector('input[type="text"], textarea');
        if (textInput && textInput.value.trim() === '') return false;

        const radioInput = inputContainer.querySelector('input[type="radio"]:checked');
        if (inputContainer.querySelector('input[type="radio"]') && !radioInput) return false;

        const checkboxInput = inputContainer.querySelector('input[type="checkbox"]:checked');
        if (inputContainer.querySelector('input[type="checkbox"]') && !checkboxInput) return false;

        const selectInput = inputContainer.querySelector('select');
        if (selectInput && selectInput.value === '') return false;
      }

      return true;
    }

    button.addEventListener('click', () => {
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      updateCustomOrderForm();
    });

    closeButton.addEventListener('click', () => {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
      }
    });
    
    if (variantPicker) {
      variantPicker.addEventListener('change', updateCustomOrderForm);
    }
    
    const gpoContainer = document.querySelector(`#ProductInfo-${sectionId} .globo-product-options`);
    if (gpoContainer) {
      gpoContainer.addEventListener('change', updateCustomOrderForm);
      gpoContainer.addEventListener('input', updateCustomOrderForm);
    }

    // Initial state
    updateCustomOrderForm();
  });
});
